import { FleekError } from './FleekError';

type GitIntegrationInstallationConflictErrorOptions = Record<string, never>;

export class GitIntegrationInstallationConflictError extends FleekError<GitIntegrationInstallationConflictErrorOptions> {
  public name = 'GitIntegrationInstallationConflictError';

  toString = () => `The Git Integration installation for this provider already exists in this project`;
}
